import { Form, FormInstance } from 'antd';

import { RecursiveRequired } from 'types';

import { IRetailerStore } from '../store';

const { useWatch } = Form;

export const useFormValues = (form: FormInstance<RecursiveRequired<IRetailerStore['initialValues']>>) => {
  const regions = useWatch(['retailerValues', 'regions'], form);
  const companyId = useWatch(['retailerValues', 'companyId'], form);

  const enRetailerName = useWatch(['enValues', 'name'], form);
  const frRetailerName = useWatch(['frValues', 'name'], form);

  const sponsorCode = useWatch(['partnerValues', 'sponsorCode'], form);
  // const manualThreshold = useWatch(['partnerValues', 'manualThreshold'], form);
  // const isManualThreshold = useWatch(['partnerValues', 'isManualThreshold'], form);
  const isEnabledBaseIssuance = useWatch(['partnerValues', 'isEnabledBaseIssuance'], form);

  const enNotFilled = !enRetailerName;
  const frNotFilled = !frRetailerName;
  // we need this for new offer for validate all fields in same time
  const isSaveBtnDisabled = enNotFilled
    || frNotFilled
    || !companyId
    || !regions?.length
    || (isEnabledBaseIssuance && !sponsorCode);
    // || (isManualThreshold && !manualThreshold);

  return {
    enNotFilled,
    frNotFilled,
    isSaveBtnDisabled,
    isEnabledBaseIssuance,
  };
};
